// API Configuration
// In production, REACT_APP_API_URL MUST be set at build time.
// In development it defaults to localhost for convenience.
const envApiUrl = process.env.REACT_APP_API_URL;

if (process.env.NODE_ENV === 'production' && !envApiUrl) {
  // Fail loudly instead of silently pointing at localhost in a shipped bundle.
  const msg =
    '[config] REACT_APP_API_URL is not set. Build the frontend with REACT_APP_API_URL=<api-origin> for production.';
  // eslint-disable-next-line no-console
  console.error(msg);
  throw new Error(msg);
}

export const API_URL = envApiUrl || 'http://localhost:5001';
